export default "__VITE_ASSET__DNNnhWMY__"